import * as zod from 'zod';

export const legacyMeRefSchema = zod.object({
  config: zod.object({
    global: zod.object({
      uploadConfiguration: zod.object({
        aiUploadDocs: zod.object({
          allowedExtensions: zod.array(zod.string()),
          allowedMimeTypes: zod.array(zod.string()),
        }),
        aiUploadImages: zod.object({
          allowedExtensions: zod.array(zod.string()),
          allowedMimeTypes: zod.array(zod.string()),
        }),
        imageUpload: zod.object({
          allowedExtensions: zod.array(zod.string()),
          allowedMimeTypes: zod.array(zod.string()),
        }),
      }),
    }),
  }),
});

export type LegacyMeRefSchema = zod.infer<typeof legacyMeRefSchema>;
